import { FGListen, FGSelectInput } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router";
import { useReferential } from "../../../../hooks/useReferential";
import { DrupalFormGenerator } from "../../../common/DrupalFormGenerator";
import { EDrupalRoutes } from "../../../EDrupalRoutes";

export interface IDrupalActivitySearchBarProps {
  onSelectionChanged?: (breedId) => void;
}

export const DrupalActivitySearchBar: React.FunctionComponent<IDrupalActivitySearchBarProps> = ({
  onSelectionChanged,
}) => {
  const [activities, aLoading] = useReferential((c) => c.getActivities(null), false, []);
  const history = useHistory();
  return (
    <DrupalFormGenerator
      initialValues={{ activity: 0 }}
      onSubmit={() => {}}
      editMode={true}
      showDeleteButton={false}
      hideButtons={true}
      saving={false}
      deleting={false}
      enableDirtyCheck={false}
    >
      <FGListen
        field="activity"
        onChanged={(value) => {
          onSelectionChanged ? onSelectionChanged(value) : history.push(`${EDrupalRoutes.breed}/${value}`);
        }}
      />
      <FGSelectInput items={activities} loading={aLoading} name="activity" leftIcon={"search"} />
    </DrupalFormGenerator>
  );
};
